
import axiosInstance from '../axiosInstance';
import { useEffect, useState, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';

import { toast } from "react-toastify";
import { API_URL_All } from '../api';
import * as general from '../libs/general';
import { fetchReconcileNormalCustomerPermissions } from "../libs/customerCreatePermission";
import Paging from '../components/Paging';
import DataTable from '../components/ui/DataTable';
import { CheckingTicket } from '../components/tickets/Tickets';
import NormalReconciliationReview from '../components/orders/NormalReconciliationReview';

function NewReconciliation() {
  const [pageOrderData, setPageOrderData] = useState({ content: [] });
  const [errorMessage, setErrorMessage] = useState("");

  const [checkingReviewData, setCheckingReviewData] = useState(null);

  const [selectedOrders, setSelectedOrders] = useState([]);

  const hasRun = useRef(false);
  const appliedCustomerRef = useRef('');

  const [params, setParams] = useState(() => {
    const saved = general.getSession('normal_reconcile_filter');
    return saved?.customers ? { customers: String(saved.customers).trim() } : {};
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [reconcilePerm, setReconcilePerm] = useState({
    loaded: false,
    canView: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });

  useEffect(() => {
    searchOrders({ page: 0 });
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchReconcileNormalCustomerPermissions(axiosInstance);
      if (!cancelled) {
        setReconcilePerm({
          loaded: true,
          canView: Boolean(p?.canView),
          canCreate: Boolean(p?.canCreate),
          canEdit: Boolean(p?.canEdit),
          canDelete: Boolean(p?.canDelete),
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleRefreshPage = (e) => {
    searchOrders();
  };

  const handleSearchClick = () => {
    const formData = general.getFormData('#normal_reconcile_filter');
    appliedCustomerRef.current = (formData.customers || '').trim();
    searchOrders({ page: 0 }, true);
  };

  const applyCustomerAutoSelect = (responseData, customerCode) => {
    const allIds = responseData.listIds
      ?? responseData.page?.content?.map((order) => order.id)
      ?? [];
    setSelectedOrders(allIds);

    const checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = allIds.length > 0;
      checkAllTag.removeAttribute('data-listIds');
      if (responseData.listIds) {
        checkAllTag.setAttribute('data-listIds', responseData.listIds.join(','));
      }
    }

    if (responseData.page?.totalElements >= 1000 && !responseData.listIds) {
      toast.warning('Quá 1000 đơn, chỉ chọn được đơn trên trang hiện tại.');
    } else if (customerCode && allIds.length === 0) {
      toast.info('Không tìm thấy đơn chưa đối soát của khách hàng này.');
    }
  };

  const searchOrders = async (filter, fromSearchButton = false) => {
    if (window.calling) return;
    window.calling = true;

    setIsLoading(true);
    setIsSearching(true);
    setErrorMessage('');

    var params = general.getSession('normal_reconcile_filter');

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('normal_reconcile_filter');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);

    if (fromSearchButton) {
      const formData = general.getFormData('#normal_reconcile_filter');
      appliedCustomerRef.current = (formData.customers || '').trim();
    }

    const customerCode = appliedCustomerRef.current;
    if (customerCode) {
      params.customers = customerCode;
    } else {
      delete params.customers;
    }

    const hasCustomerFilter = Boolean(customerCode);

    if (!hasCustomerFilter) {
      var checkAllTag = document.querySelector('.check_all');
      if (checkAllTag) {
        checkAllTag.removeAttribute('data-unchecked');
        checkAllTag.checked = false;
      }
      setSelectedOrders([]);
    }

    general.setSession('normal_reconcile_filter', params);
    setParams(params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};

    setErrorMessage("");
    setPageOrderData({ content: [] });
    try {
      response = await axiosInstance.get('/api/import-orders/searchNormalOrders', { params: filteredParams });
      setPageOrderData(response.data);
      var processedOrders = response.data.page.content;

      if (hasCustomerFilter) {
        applyCustomerAutoSelect(response.data, customerCode);
      } else {
        var checkAllTag = document.querySelector('.check_all');
        if (checkAllTag) {
          checkAllTag.removeAttribute('data-listIds');
          if (response.data.listIds) {
            checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
          }
          var uncheckedList = checkAllTag.getAttribute('data-unchecked');
          if (uncheckedList || checkAllTag.checked) {
            if (!uncheckedList) uncheckedList = '';
            var uncheckedItems = uncheckedList.split(',').map(item => parseInt(item.trim())).filter(Number.isInteger);
            setSelectedOrders(processedOrders.filter(order => !uncheckedItems.includes(order.id)).map(order => order.id));
          }
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
      console.error(error);
    } finally {
      window.calling = false;
      setIsSearching(false);
      setIsLoading(false);
    }
  };

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchOrders({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchOrders({ page: page - 1 });
  };

  const prepareChecking = async (params) => {
    if (isChecking) return;
    if (!reconcilePerm.loaded || !reconcilePerm.canCreate) {
      toast.warning("Bạn không có quyền tạo đối soát.");
      return;
    }
    var listIds = selectedOrders;
    if (listIds.length === 0) {
      toast.error('Phải chọn ít nhất một mục.');
      return;
    }
    setIsChecking(true);
    try {
      var params = { listIds: selectedOrders };
      var isValid = await validateInvoice(params);
      if (isValid) setCheckingReviewData(params);
    } finally {
      setIsChecking(false);
    }
  };

  const validateInvoice = async (params) => {
    try {
      var urlApi = `/api/invoices/getNormalInvoiceReview`;
      var listIds = { codes: params.listIds.join(';') };
      const response = await axiosInstance.post(urlApi, listIds,
        { headers: { 'Content-Type': 'application/json' } });
      var obj = response.data;
      if (obj.success === false) {
        toast.error(obj.message);
        return false;
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
      return false;
    }
    return true;
  }

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  }
  const handleSelectOrder = (id) => {
    setSelectedOrders((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var totalNumberPages = pageOrderData.page.totalPages;
      var checkallTag = document.querySelector('.check_all');
      if (totalNumberPages === 1 && pageOrderData.listIds) {
        const allChecked = pageOrderData.listIds.every(orderId => updated.includes(orderId));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalNumberPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {
          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(pageOrderData.listIds);
    }
  };

  return (
    <>
      <div className="table-responsive web-table">
        <div className="container-fluid pt-2">
          <div className="text-start mb-2 normal-form">
              <div className="row">
              <div className="col-md-8">
                <form id="normal_reconcile_filter">
                  <div className="row">
                    <div className="col-md-7 height-46">
                      <div className="row">
                        <label className="form-label col-form-label col-md-4 text-end">Mã khách hàng</label>
                        <div className="col-md-8">
                          <div className="th th-col filter-editor">
                            <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'}>
                              <input
                                type="text"
                                name="customers"
                                placeholder="Nhập mã khách hàng..."
                                autoComplete="off"
                                defaultValue={params.customers || ''}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 p-0">
                      <button
                        onClick={handleSearchClick}
                        className="btn btn-light btn-sm d-inline-flex align-items-center justify-content-center zto-btn-icon-sm"
                        type="button"
                        title="Tìm kiếm..."
                        disabled={isSearching}
                        aria-busy={isSearching}
                      >
                        {isSearching ? (
                          <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        ) : (
                          <FaSearch />
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-4 col-md-1 p-0">

                <div>
                  {reconcilePerm.loaded && reconcilePerm.canCreate && (
                    <button 
                      onClick={(e) => prepareChecking(e)} 
                      type="button" 
                      className="btn btn-info btn-sm me-2 d-inline-flex align-items-center justify-content-center gap-1 zto-btn-min-122"
                      disabled={isChecking || isSearching}
                      aria-busy={isChecking}>
                      {isChecking ? (
                        <>
                          <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                          Đang xử lý
                        </>
                      ) : (
                        'Tạo đối soát'
                      )}
                    </button>
                  )}
                </div>
              </div>

              </div>

          </div>
        </div>
        <section className="p-1 ">
          <DataTable maxHeight="calc(100vh - 220px)" className="table-normal" data-loading={isLoading}>
            <table className="table table-striped border-normal table-bordered">
              <thead className="table-primary">
                <tr>
                  <th className='sticky' width="21px">
                    <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                  </th>

                  <th className="text-center"><span>Ngày</span></th>
                  <th className="text-center">Mã vận đơn TQ</th>
                  <th>Line</th>

                  <th className="text-center">Số kiện</th>
                  <th className="text-center"><span data-note="">Kg</span></th>
                  <th className="text-center"><span data-note="">M3</span></th>

                  <th className="text-center"><span data-note="">Tổng cước</span></th>

                  <th>Lưu trình</th>
                  <th className="text-center">Mã KH</th>
                </tr>
              </thead>
              {pageOrderData.page && pageOrderData.page.content && pageOrderData.page.content.map((item, index) => (
                <tbody className="tbody-row" key={index}>
                  <tr>
                    <td className='sticky' title={item.id}>
                      <input
                        type="checkbox"
                        checked={selectedOrders.includes(item.id)}
                        onChange={() => handleSelectOrder(item.id)}
                      />
                    </td>

                    <td className="text-success text-center" title={general.formatTimeShort(item.createdDate)}>{general.formatDate(item.createdDate)}</td>
                    <td className="text-success text-center">{item.cnShippingCode}</td>
                    <td className="text-success text-start">{item.lineName}</td>

                    <td className="text-success text-center">{general.formatNumber(item.packageNumbers)}</td>
                    <td className="text-success text-center">{general.formatDecimal(item.packageUnitValue)}</td>
                    <td className="text-success text-center">{general.formatDecimal(item.packageUnitM3)}</td>

                    <td className="text-success text-center">
                      <span className="pe-1">{general.formatNumber(item.maxFreghtCost)}</span>
                      <CheckingTicket checkingId={item.statusRateId} checkingName={item.statusRateName} />
                    </td>

                    <td className="text-success text-start">{item.statusName}</td>
                    <td className="text-success text-center">{item.customerCode}</td>
                  </tr>
                </tbody>
              ))}


              <tbody>
                {errorMessage === '' && pageOrderData.page && pageOrderData.page.content.length === 0 && (
                  <tr>
                    <td colSpan="21" className="text-center">Không tìm thấy dữ liệu</td>
                  </tr>
                )}
                {errorMessage !== '' && (
                  <tr>
                    <td colSpan="21" className="text-center">{errorMessage}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </DataTable>
        </section>

        <div className="my-1 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageOrderData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
              isShowTotal={true}
              showCheckingFeeTotal={true}
              checkingFeeTotalLabel="Tổng cước"
            />
        </div>

        {checkingReviewData && (
          <NormalReconciliationReview data={checkingReviewData} handleSearch={handleRefreshPage} canEdit={reconcilePerm.canEdit} />
        )}

      </div >
    </>
  );
}
export default NewReconciliation;
